import { createModel } from 'xstate/lib/model';

import baseEvents from 'features/Bento/libs/machines/config/baseEvents';
import { OnboardingModuleData } from 'features/Onboarding/machine/model';

type OnboardingStandardModuleData = OnboardingModuleData;

const context = {
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => OnboardingStandardModuleData,
};

export type Context = typeof context;

const model = createModel(
  context,

  {
    events: {
      ABORT_APPLICATION: () => ({}),

      'error.platform.submitApplication': (data: Error) => ({ data }),
      GO_CAPITAL_DEPOSIT: () => ({}),
      GO_RESET_PROMPT: () => ({}),

      ...baseEvents,
    },
  },
);

export default model;

export type Model = typeof model;
